if (!customElements.get('m-cart-shipping-goal')) {
  class MCartShippingGoal extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 29900;
      this.progressMessageTemplate =
        this.dataset.progressMessage || 'Faltam [amount] para você ganhar frete grátis!';
      this.successMessage = this.dataset.successMessage || 'Parabéns! Você ganhou frete grátis!';
      this.useCurrencyCode = this.dataset.currencyCodeEnabled === 'true';

      this.progressEl = this.querySelector('[data-shipping-goal-progress]');
      this.successEl = this.querySelector('[data-shipping-goal-success]');
      this.barEl = this.querySelector('[data-shipping-goal-bar]');
      this.progressWrap = this.querySelector('.foxkit-cartgoal__progress');

      this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.cartUpdate,
        ({ cart }) => this.update(cart)
      );

      this.handleCartUpdated = (event) => {
        if (event.detail?.cart) {
          this.update(event.detail.cart);
        }
      };

      document.addEventListener('cart:updated', this.handleCartUpdated);
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      document.removeEventListener('cart:updated', this.handleCartUpdated);
    }

    formatAmount(cents) {
      if (typeof window.formatMoney === 'function') {
        return formatMoney(cents, window.MinimogSettings?.money_format || this.dataset.moneyFormat);
      }

      return (cents / 100).toFixed(2).replace('.', ',');
    }

    renderProgressMessage(remainingCents) {
      const amount = this.formatAmount(remainingCents);
      return this.progressMessageTemplate
        .replace(/\[amount\]/g, amount)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    update(cart) {
      if (!cart) return;

      const itemCount = cart.item_count || 0;
      const total = cart.total_price || 0;
      const remaining = Math.max(this.threshold - total, 0);
      const progress = Math.min(Math.round((total * 100) / this.threshold), 100);
      const reached = itemCount > 0 && total >= this.threshold;

      this.classList.toggle('m:hidden', itemCount === 0);
      this.classList.toggle('is-success', reached);

      if (this.progressEl) {
        this.progressEl.innerHTML = reached ? '' : this.renderProgressMessage(remaining);
      }

      if (this.successEl && this.successMessage) {
        this.successEl.textContent = this.successMessage;
      }

      if (this.barEl) {
        this.barEl.style.width = `${progress}%`;
      }

      if (this.progressWrap) {
        this.progressWrap.setAttribute('aria-valuenow', String(progress));
      }
    }
  }

  customElements.define('m-cart-shipping-goal', MCartShippingGoal);
}
